import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Fa from "react-icons/fa";
import Axios from "../../../api/Axios";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
 
const url = "UserGroups/";
const GetuserGroup_url = `${url}SaveAllUserGroupData?`;

 
const UserGroupsDetails = () => {
    const nav = useNavigate();
    const auth = storage.getLocal("user");
    const location = useLocation();
    const selectedGroup = location.state?.selectedGroup || null;
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        pvcgR_ID: selectedGroup?.MASK_GR_ID || "",
        pvcgR_CODE: selectedGroup?.CODE || "",
        pvcgR_NAME: selectedGroup?.GR_NAME || "",
        pvcdefineD_BY: selectedGroup?.MASK_DEFINED_BY || "E",
        pvcstatus: selectedGroup?.MASK_STATUS || "Y",
        pvcremarks: selectedGroup?.MASK_REMARKS || "",
        pvccomP_ID: auth?.CompId || "",
        pvcentereD_BY:auth.UserId,
        iukey: selectedGroup ? "2" : "1", // 1=Insert, 2=Update
    });
 
 
    useEffect(() => {
        if (selectedGroup) {
            setFormData({
                pvcgR_ID: selectedGroup?.MASK_GR_ID || "",
                pvcgR_CODE: selectedGroup?.CODE || "",
                pvcgR_NAME: selectedGroup?.GR_NAME || "",
                pvcdefineD_BY: selectedGroup?.MASK_DEFINED_BY || "E",
                pvcstatus: selectedGroup?.MASK_STATUS || "Y",
                pvcremarks: selectedGroup?.MASK_REMARKS || "",
                pvccomP_ID: auth?.CompId || "",
                pvcentereD_BY:auth.UserId,
                iukey: selectedGroup ? "2" : "1", // 1=Insert, 2=Update
            });
        }
    }, [selectedGroup]);
 
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
 
    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            let payload = { ...formData };
 
            const response = await Axios.post(GetuserGroup_url, payload);
            console.log("Response",response);
            toast.success("Data saved successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            nav("/usermanagement/usergroup/usergroupfield");
            setIsLoading(false);
        } catch (error) {
            toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
            setIsLoading(false);
        }
    };
 
    return (
        <>
            {
 
                isLoading ?
                    <Loader/> :
                    <div className="col-12 pt-0 pb-4">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb mx-1">
                                        <li className="breadcrumb-item">
                                            <Link to="/usermanagement/usergroup/usergroupfield">
                  User Groups
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                Details
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="float-end">
                                    <Link to="/usermanagement/usergroup/usergroupfield">
                                        <button type="submit" className="btn btn-primary">
                                            <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                Records
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <section className="sales-box">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-lg-5 col-md-12 col-sm-12">
                                    <form>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="d-block mb-2">
                                                <label className="form-label">
                    Code <span className="mandatory">*</span>
                                                </label>
                                                <InputText
                                                    name="pvcgR_CODE"
                                                    value={formData.pvcgR_CODE}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    // disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="d-block mb-2">
                                                <label className="form-label">
                    Name <span className="mandatory">*</span>
                                                </label>
                                                <InputText
                                                    name="pvcgR_NAME"
                                                    value={formData.pvcgR_NAME}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="d-block mb-2">
                                                <label className="form-label">Remarks </label>
                                                <InputText
                                                    name="pvcremarks"
                                                    value={formData.pvcremarks}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                                            <label className="form-label">
                  Status<span className="mandatory">*</span>
                                            </label>
                                            <div className="d-block">
                                                <RadioButton
                                                    name="pvcstatus"
                                                    value="Y"
                                                    checked={formData.pvcstatus === "Y"}
                                                    onChange={handleChange}
                                                />
                                                <label className="mx-2">Active</label>
                                                <RadioButton
                                                    name="pvcstatus"
                                                    value="N"
                                                    checked={formData.pvcstatus === "N"}
                                                    onChange={handleChange}
                                                />
                                                <label className="mx-2">Inactive</label>
                                            </div>
                                        </div>
 
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                            <div className="text-end mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleSubmit}
                                                >
                                                    {selectedGroup ? "Update" : "Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12">
                                    <div className="text-end">
                                        <img
                                            src={require("../../../Assets/Images/users_group.png")}
                                            className="Side_Img"
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
            }
        </>
    );
};
 
export default UserGroupsDetails;